/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-03-18 15:10:57
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-07-21 18:04:33
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorTabbar/slice/index.ts
 */
import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from '@reduxjs/toolkit';
import moment from 'moment';

import { uuid } from '@/src/tools/helper';
import { assData } from 'src/pages/SalesChannelContentEditor/slice/reduxCommonFunctions';
import {
  getContentTabBar,
  postContentTabBar,
} from 'src/request/salesChannel/content';
import { msg } from 'src/tools/message';
import { convertDataFromServerToRedux, generateTabBarSetting } from '../tools';

import { getI18nFromGeneral } from '@/src/tools/tools';
import { isCurrentPrimary } from 'src/constrains/SalesChannelMultiLanguageSelect';
import {
  EnumReducers,
  getLoaded as _getLoaded,
  getState as _getState,
} from 'src/pages/SalesChannelContentEditor/slice/selectors';
import { reduxUpdatedStatusControl } from 'src/tools/helper';
import { validation as validationTabBar } from '../validation';

export const request_tabBar = createAsyncThunk(
  'fetchSalesChannelContentTabBar',
  async (
    data: any,
    //thunkAPI,
  ) => {
    const { uuid, params = {}, isClone } = data;
    const isPrimary = isCurrentPrimary();
    const response = await getContentTabBar(uuid, params);
    return { response, isClone, isPrimary };
  },
);

export const request_saveTabBar = createAsyncThunk(
  'submitSalesChannelContentTabBar',
  async (data: any) => {
    const { body, isPrimary, params } = data;
    const { body: _b, uuid } = body;
    const response = await postContentTabBar(_b, uuid, params);
    return { response, isPrimary };
  },
);

const defaultState = {
  loading: false,
  ...reduxUpdatedStatusControl,
  openList: [],
  timezoneGmt: '',
  salesChannelContent: '',
  salesChannelName: '',
  contentUuid: '',
  originalSetting: {
    id: uuid(),
    name: 'Default Tab Bar',
    display: 'fixed',
    backgroundColor: '#fff',
    inactiveColor: '#5C6269',
    activeColor: '#000',
    isDefault: true,
    tabs: [
      {
        draggableId: uuid(),
        title: '首页',
        isHome: true,
        icon: {
          url: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFEAAABRCAYAAACqj0o2AAAABGdBTUEAALGPC/xhBQAAA6VJREFUeAHtnNuLTWEYxsc43DiN8yGHkVMiuXU3V/4gKUVKSimFUiKpSUlKUq64lGOSQyKHmMghXLh2w/Mb89TYDfv0rr3X2vt9622+tdb3Pe/z/Pqai7mYgYGsJJAEkkASSAJJoFwEppXLzl9uduppl3qj+rX6hvquOqsBArO154z61xTNe75n/YfAHH27qTbAn1pzC/npd3xnX9YUBObq3S21YV3XetnEPn7y7G/sY3/WJALztL6jNqRrWs+a9J0lz7z3HvZzLksE5qvvqQ3nqta1APVqvHjPd+/lHOf7uoaU/r7aUK5oPbMOEb6zz2c4j05f1gKlfqA2jMtaz2iQBPvY77PooNdXtVBpH6oN4ZLWjQI0KPZzzhroodsXtUgpH6kd/qLW01tMzjnOWwtd9Hu6FivdE7VDX9C6VYAGxXl0rIk+c3qylijVU7XDntd6MCgpOuhZmznM66laqjTP1A45qnUUQEmNF3qjas9gHnN7opYrxXO1w53TOhqgQaGLvmcxl/mVrhVy/0LtUGe1LvovR+gzxzOZj49K1kq5fql2mNNaFw3QoJjDPM/GB34qVavk9pXaIU5p3SmABsU85toDfvBViVotl2/UNn+yy66Zby/4wl+pa43cvVXb9ImSuMWHPeEPn6WsYbl6p7bZYyVziR97w+dwyfwNrJOhMbVNHi2bwQk/+LLHMa3xXYpaLxfv1TZ3pBSu/m0Cf/aKb/x3tTZo+ge1TR3uqpvGh+PTnvFPjq7UJk39qLaZQ11x0fpQ/No7OcjT0dqsaZ/UNnGwo9PjhuHbGchDro7UFk35rPbwAx2ZWtwQ/DsLuchXaG2V+he1h+4rdFrnxMnhTOQjZyG1Tapf1R62t5Ap3RMlj7ORk7yhtV1q39QesidUvTxi5HJG8pI7pNZK5bva4rtDVMsrQj5nJTf5264RKVh0f9tq1RAgpzOP1LM8WG9DzffbNc+9+thUzmYh9iq0tnIlxLbw/TmcEBNiAIEAibyJCTGAQIBE3sSEGEAgQCJvYkIMIBAgkTcxIQYQCJDIm5gQAwgESORNTIgBBAIk8iYmxAACARJ5ExNiAIEAibyJCTGAQIBE3sSEGEAgQCJvYkIMIBAgkTcxIQYQCJDIm5gQAwgESORNTIgBBAIk8iYmxAACARJ5ExNiAIEAiWb/P9eOgJlVkGgqZ7MQj1eBQKc95u/EAOL825N6NaQNTV3veoIV+/5Yfn9UzHPaTQJJoDUCvwFWDdss+OLx7QAAAABJRU5ErkJggg==',
        },
      },
      {
        draggableId: uuid(),
        title: '全部产品',
        isHome: false,
        icon: {
          url: 'data:image/png;base64,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',
        },
      },
      {
        draggableId: uuid(),
        title: '购物车',
        isHome: false,
        icon: {
          url: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFEAAABRCAYAAACqj0o2AAAABGdBTUEAALGPC/xhBQAABW9JREFUeAHtmklv1EAQhYedEAhL2AkowAUJhJD4/yduXDihCARS2MO+JWFf3mdNjzwet+142j22p570GMfj6eV1VXV1mcHAYAqYAqaAKWAKmAKmgClgCpgCpoApYAqYAqaAKWAKmAKmgCkQTYFdmZ726u+L4mVxv/hPzAO/eyM+FDfzHpine1kRb2nyiFgVX/XgHfFP1R/08bk9mUn90t8LIuL+LuBufQcPiB/ELXFukbVEJwRuXYQj+vK2iODPxXvi3CJriU6Iv7oo4nd9TyxcEQ+KCDm3Lo1L1sV7/ZCYyAZ0tm4jffjdNCJieS+HIlzQpy809EGnwjlMIyINvxJx++MicXIuMa2IxEV2Z9o5P5cKatJlu3CZLiTjz8STIiI+EkmNqgD3Z2MjpnYpFDDnnyLhLDmMTCui2hm8FX+IiyJibohVQI55UzwmTusRVfoL9QzCsaGuiR9pNISICPhavCSywXCdrJA+i4CIiN4VK2ScbqzLuj4jBhNRbQ1eiIh4SiRv/CaW4YseuCtiib58tayNmN8zxlWRTzZTl5kEsUS1l6wIJs4OzQqti2XAWt8NWfZsW75nwbFCDIBNNUGoWJTNGUO168bZhk/m5MIfFSysMUHIyZIzIiY541LSer/+IYazeeJBiDhCSBExb3JGgm8fc0aMA0ukYoU7jxBSRFaIDQZwlnamn9zowT/nhnPACvG4EUKKSKN0kM4ZRx11/IIDwYnhHEjhxhBaRAR08aJPRQlcmdRtW/wsjiG0iDTuXNrljGMddvQP0jZASkb1fwxNiEgWzyazT+xDnZHYjkGACVfmZhMiUoBw2Ty7dBN9MPZYIME+JBKqyD4m0NQEyRlJRvuQM54eqkYln+rNBJoSkSNgH3JGzslORG91qikR0zkj+RXxsYugFnBYZDPJdWUm1ZSItE0Q5q0g8cQFZl12CuzKnMBwZW9lqkkR0zkjG4yrxemyE0Ab58q5u7KbRZMi0ge7NK5N8RWL7BJw4yWRbIP80IumRexyzkgIQh/m4HVllG1aRFaRdAfg0l2oYDNWQo87pXCMxZu8aFpEOnZ1xqO6xj26AEIP46Vaw4u4QsQQkZwRl2B1u1KUIIZz3KNuuCUWIoaI6ZwRF2l7zph15dFrAJ+SMUSkb/duGjdhldsMSl4cV1l84mEpYonI7uZiS9tzRoqvFGEJQ7AUsURkINQZXc64UDqy2TyQdeWx1wC+IcUUkbMnQbrNdUYscHkoViVX5tmYIqZzRnbptr3IwgpxZWIiiz3xGkD3chF7IuSMV0RysFXxqViYyOr7WMAKGRsgfrPolRBbRAL1JxGXuSZSaqo8WD3bJKhgQxa1sOCQHURsEcm51kXEo+8VsS1APDYSFtlbO8wbbGwRGYM7S1OsJW+MGZfp3wc8AgGfiDvyDoLpLMEitkFErBAvqZTSZAWbtYjp8SAoVR4msiNLSDdS8Zp+IOLRF5+10YbSFJZIAZR31Gw4JOIIOfGSXPdCgBSGoydVa6pKGBJ9lZ6R9UwuZhETswNhk7kuuiQXqyDRvS+WVlD0zE5Aon9VvCS6uW/rek0kVteyyFlbIlaAgK4AqsvEMrBMLMOdt7kfAljfDTEdhxGWvJVXGbViYroxtREdWIOzwGznuFzomO2rIC2qL1gLsxaRQftW33e/1kSHP/K1iRvXcmXanbWI7IycDrJBnfsbYu2J6bd5IDzwKjcLKu+b2ZtV/551TGScDJ4dmdiEexPoEfax6LMcfVUL1DUJEfRHXywWhYYHYm0RQ8ccjaUWEJCgTxWFnZn3vKEFVJMJmDMbCcVh/ocGuzLiGkwBU8AUMAVMAVPAFDAFTAFTwBQwBUyBPAX+A4mb8y23wQ7eAAAAAElFTkSuQmCC',
        },
      },
      {
        draggableId: uuid(),
        title: '个人中心',
        isHome: false,
        icon: {
          url: 'data:image/png;base64,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',
        },
      },
    ],
  },
  defaultSetting: {
    id: uuid(),
    originalId: '',
    name: 'Default Tab Bar',
    display: 'fixed',
    backgroundColor: '#fff',
    inactiveColor: '#5C6269',
    activeColor: '#000',
    isDefault: true,
    showError: false,
    tabs: [
      {
        draggableId: uuid(),
        title: '首页',
        isHome: true,
        icon: {
          url: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFEAAABRCAYAAACqj0o2AAAABGdBTUEAALGPC/xhBQAAA6VJREFUeAHtnNuLTWEYxsc43DiN8yGHkVMiuXU3V/4gKUVKSimFUiKpSUlKUq64lGOSQyKHmMghXLh2w/Mb89TYDfv0rr3X2vt9622+tdb3Pe/z/Pqai7mYgYGsJJAEkkASSAJJoFwEppXLzl9uduppl3qj+rX6hvquOqsBArO154z61xTNe75n/YfAHH27qTbAn1pzC/npd3xnX9YUBObq3S21YV3XetnEPn7y7G/sY3/WJALztL6jNqRrWs+a9J0lz7z3HvZzLksE5qvvqQ3nqta1APVqvHjPd+/lHOf7uoaU/r7aUK5oPbMOEb6zz2c4j05f1gKlfqA2jMtaz2iQBPvY77PooNdXtVBpH6oN4ZLWjQI0KPZzzhroodsXtUgpH6kd/qLW01tMzjnOWwtd9Hu6FivdE7VDX9C6VYAGxXl0rIk+c3qylijVU7XDntd6MCgpOuhZmznM66laqjTP1A45qnUUQEmNF3qjas9gHnN7opYrxXO1w53TOhqgQaGLvmcxl/mVrhVy/0LtUGe1LvovR+gzxzOZj49K1kq5fql2mNNaFw3QoJjDPM/GB34qVavk9pXaIU5p3SmABsU85toDfvBViVotl2/UNn+yy66Zby/4wl+pa43cvVXb9ImSuMWHPeEPn6WsYbl6p7bZYyVziR97w+dwyfwNrJOhMbVNHi2bwQk/+LLHMa3xXYpaLxfv1TZ3pBSu/m0Cf/aKb/x3tTZo+ge1TR3uqpvGh+PTnvFPjq7UJk39qLaZQ11x0fpQ/No7OcjT0dqsaZ/UNnGwo9PjhuHbGchDro7UFk35rPbwAx2ZWtwQ/DsLuchXaG2V+he1h+4rdFrnxMnhTOQjZyG1Tapf1R62t5Ap3RMlj7ORk7yhtV1q39QesidUvTxi5HJG8pI7pNZK5bva4rtDVMsrQj5nJTf5264RKVh0f9tq1RAgpzOP1LM8WG9DzffbNc+9+thUzmYh9iq0tnIlxLbw/TmcEBNiAIEAibyJCTGAQIBE3sSEGEAgQCJvYkIMIBAgkTcxIQYQCJDIm5gQAwgESORNTIgBBAIk8iYmxAACARJ5ExNiAIEAibyJCTGAQIBE3sSEGEAgQCJvYkIMIBAgkTcxIQYQCJDIm5gQAwgESORNTIgBBAIk8iYmxAACARJ5ExNiAIEAiWb/P9eOgJlVkGgqZ7MQj1eBQKc95u/EAOL825N6NaQNTV3veoIV+/5Yfn9UzHPaTQJJoDUCvwFWDdss+OLx7QAAAABJRU5ErkJggg==',
        },
      },
      {
        draggableId: uuid(),
        title: '全部产品',
        isHome: false,
        icon: {
          url: 'data:image/png;base64,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',
        },
      },
      {
        draggableId: uuid(),
        title: '购物车',
        isHome: false,
        icon: {
          url: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFEAAABRCAYAAACqj0o2AAAABGdBTUEAALGPC/xhBQAABW9JREFUeAHtmklv1EAQhYedEAhL2AkowAUJhJD4/yduXDihCARS2MO+JWFf3mdNjzwet+142j22p570GMfj6eV1VXV1mcHAYAqYAqaAKWAKmAKmgClgCpgCpoApYAqYAqaAKWAKmAKmgCkQTYFdmZ726u+L4mVxv/hPzAO/eyM+FDfzHpine1kRb2nyiFgVX/XgHfFP1R/08bk9mUn90t8LIuL+LuBufQcPiB/ELXFukbVEJwRuXYQj+vK2iODPxXvi3CJriU6Iv7oo4nd9TyxcEQ+KCDm3Lo1L1sV7/ZCYyAZ0tm4jffjdNCJieS+HIlzQpy809EGnwjlMIyINvxJx++MicXIuMa2IxEV2Z9o5P5cKatJlu3CZLiTjz8STIiI+EkmNqgD3Z2MjpnYpFDDnnyLhLDmMTCui2hm8FX+IiyJibohVQI55UzwmTusRVfoL9QzCsaGuiR9pNISICPhavCSywXCdrJA+i4CIiN4VK2ScbqzLuj4jBhNRbQ1eiIh4SiRv/CaW4YseuCtiib58tayNmN8zxlWRTzZTl5kEsUS1l6wIJs4OzQqti2XAWt8NWfZsW75nwbFCDIBNNUGoWJTNGUO168bZhk/m5MIfFSysMUHIyZIzIiY541LSer/+IYazeeJBiDhCSBExb3JGgm8fc0aMA0ukYoU7jxBSRFaIDQZwlnamn9zowT/nhnPACvG4EUKKSKN0kM4ZRx11/IIDwYnhHEjhxhBaRAR08aJPRQlcmdRtW/wsjiG0iDTuXNrljGMddvQP0jZASkb1fwxNiEgWzyazT+xDnZHYjkGACVfmZhMiUoBw2Ty7dBN9MPZYIME+JBKqyD4m0NQEyRlJRvuQM54eqkYln+rNBJoSkSNgH3JGzslORG91qikR0zkj+RXxsYugFnBYZDPJdWUm1ZSItE0Q5q0g8cQFZl12CuzKnMBwZW9lqkkR0zkjG4yrxemyE0Ab58q5u7KbRZMi0ge7NK5N8RWL7BJw4yWRbIP80IumRexyzkgIQh/m4HVllG1aRFaRdAfg0l2oYDNWQo87pXCMxZu8aFpEOnZ1xqO6xj26AEIP46Vaw4u4QsQQkZwRl2B1u1KUIIZz3KNuuCUWIoaI6ZwRF2l7zph15dFrAJ+SMUSkb/duGjdhldsMSl4cV1l84mEpYonI7uZiS9tzRoqvFGEJQ7AUsURkINQZXc64UDqy2TyQdeWx1wC+IcUUkbMnQbrNdUYscHkoViVX5tmYIqZzRnbptr3IwgpxZWIiiz3xGkD3chF7IuSMV0RysFXxqViYyOr7WMAKGRsgfrPolRBbRAL1JxGXuSZSaqo8WD3bJKhgQxa1sOCQHURsEcm51kXEo+8VsS1APDYSFtlbO8wbbGwRGYM7S1OsJW+MGZfp3wc8AgGfiDvyDoLpLMEitkFErBAvqZTSZAWbtYjp8SAoVR4msiNLSDdS8Zp+IOLRF5+10YbSFJZIAZR31Gw4JOIIOfGSXPdCgBSGoydVa6pKGBJ9lZ6R9UwuZhETswNhk7kuuiQXqyDRvS+WVlD0zE5Aon9VvCS6uW/rek0kVteyyFlbIlaAgK4AqsvEMrBMLMOdt7kfAljfDTEdhxGWvJVXGbViYroxtREdWIOzwGznuFzomO2rIC2qL1gLsxaRQftW33e/1kSHP/K1iRvXcmXanbWI7IycDrJBnfsbYu2J6bd5IDzwKjcLKu+b2ZtV/551TGScDJ4dmdiEexPoEfax6LMcfVUL1DUJEfRHXywWhYYHYm0RQ8ccjaUWEJCgTxWFnZn3vKEFVJMJmDMbCcVh/ocGuzLiGkwBU8AUMAVMAVPAFDAFTAFTwBQwBUyBPAX+A4mb8y23wQ7eAAAAAElFTkSuQmCC',
        },
      },
      {
        draggableId: uuid(),
        title: '个人中心',
        isHome: false,
        icon: {
          url: 'data:image/png;base64,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',
        },
      },
    ],
  },
  newTabBarSettingList: [],
  TabBarSettingList: [],
  isDataValid: false,
  hasModified: false,
};

const salesChannelContentTabBar = createSlice({
  name: 'salesChannelContentTabBar',
  initialState: defaultState,
  reducers: {
    onDefaultChange: (state, action) => {
      state.hasModified = true;
      state.defaultSetting = action.payload;
    },
    onCustomSettingChange: (state, action) => {
      state.hasModified = true;
      const setting = action.payload;
      const index = state.TabBarSettingList.findIndex(
        (i) => i.id === setting.id,
      );
      if (index >= 0) {
        state.TabBarSettingList[index] = setting;
      }
    },
    onDeleteTabBarSetting: (state, action) => {
      state.hasModified = true;
      const id = action.payload;
      const index1 = state.newTabBarSettingList.findIndex((v) => v.id === id);
      const index2 = state.TabBarSettingList.findIndex((v) => v.id === id);
      if (index1 !== -1) {
        state.newTabBarSettingList.splice(index1, 1);
      }
      if (index2 !== -1) {
        state.TabBarSettingList.splice(index2, 1);
      }
    },
    onDuplicateSetting: (state, action) => {
      state.hasModified = true;
      const id = action.payload;
      const index1 = state.newTabBarSettingList.findIndex((v) => v.id === id);
      const index2 = state.TabBarSettingList.findIndex((v) => v.id === id);
      if (index1 !== -1) {
        const newId = uuid();
        state.TabBarSettingList.push({
          ...state.newTabBarSettingList[index1],
          id: newId,
          originalId: '',
          startTime: null,
          endTime: null,
        });
      }
      if (index2 !== -1) {
        const newId = uuid();
        state.TabBarSettingList.push({
          ...state.TabBarSettingList[index2],
          id: newId,
          startTime: null,
          endTime: null,
        });
      }
    },
    onNewSettingChange: (state, action) => {
      state.newTabBarSettingList = [action.payload];
    },
    onRestoreDefaultSetting: (state) => {
      state.hasModified = true;
      state.defaultSetting = {
        ...state.originalSetting,
        showError: false,
        isDefault: true,
        name: 'Default Tab Bar',
        id: state.defaultSetting.id,
        originalId: state.defaultSetting.originalId,
      };
    },
    onAddNewCustomerSetting: (state) => {
      state.hasModified = true;
      const tabBar = generateTabBarSetting(
        state.originalSetting,
        state.TabBarSettingList.length + 1,
      );
      if (state.newTabBarSettingList.length > 0) {
        const previousItem = state.newTabBarSettingList[0];
        state.TabBarSettingList.push(previousItem);
        state.newTabBarSettingList = [tabBar];
      } else {
        state.newTabBarSettingList.push(tabBar);
      }
      state.openList = [tabBar.id];
    },
    onOpenTabBarSetting: (state, action) => {
      const index = state.defaultSetting.id === action.payload ? 1 : -1;
      const index1 = state.TabBarSettingList.findIndex(
        (v) => v.id === action.payload,
      );
      const index2 = state.newTabBarSettingList.findIndex(
        (v) => v.id === action.payload,
      );
      if (index !== -1) state.defaultSetting.showError = true;
      if (index1 !== -1) state.TabBarSettingList[index1].showError = true;
      if (index2 !== -1) state.newTabBarSettingList[index2].showError = true;
      if (state.openList.indexOf(action.payload) !== -1) {
        state.openList = [];
      } else {
        state.openList = [action.payload];
      }
    },
    onFinishAddingNew: (state, action) => {
      const previousItem = state.newTabBarSettingList[0];
      if (previousItem) state.TabBarSettingList.push(previousItem);
      state.newTabBarSettingList = [];
    },
    validation: (state, action) => {
      const { isPrimary } = action.payload;
      let hasError = false;
      if (Array.isArray(state.TabBarSettingList)) {
        const err = state.TabBarSettingList.some(
          (v) => validationTabBar(v, isPrimary).length !== 0,
        );
        hasError = err || hasError;
      }
      if (Array.isArray(state.newTabBarSettingList)) {
        const err = state.newTabBarSettingList.some(
          (v) => validationTabBar(v, isPrimary).length !== 0,
        );
        hasError = err || hasError;
      }
      if (state.defaultSetting) {
        const err =
          validationTabBar(state.defaultSetting as any, isPrimary).length !== 0;
        hasError = err || hasError;
      }
      state.isDataValid = !hasError;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(request_tabBar.pending, (state) => {
      state.loaded = false;
    });
    builder.addCase(request_tabBar.rejected, (state) => {
      state.loaded = true;
    });
    builder.addCase(request_tabBar.fulfilled, (state, action) => {
      const { response, isClone } = action.payload;
      const s = convertDataFromServerToRedux(response);
      assData(state, s);
      if (isClone) state.hasModified = true;

      // state.loading = false;
      // state.defaultSetting = s.defaultSetting;
      // state.TabBarSettingList = s.TabBarSettingList;
      // state.originalSetting = s.originalSetting;
      // state.timezoneGmt = s.timezoneGmt;
      // state.salesChannelContent = s.salesChannelContent;
      // state.salesChannelName = s.salesChannelName;
      // state.contentUuid = s.contentUuid;
    });

    builder.addCase(request_saveTabBar.fulfilled, (state, action) => {
      // const s = convertDataFromServerToRedux(action.payload);
      msg.success(getI18nFromGeneral('general.status.changessavesuccessfully'));
      // state.defaultSetting = s.defaultSetting;
      // state.TabBarSettingList = s.TabBarSettingList;
      // state.originalSetting = s.originalSetting;
      // state.timezoneGmt = s.timezoneGmt;
      const { response } = action.payload;
      const s = convertDataFromServerToRedux(response);
      state.newTabBarSettingList = [];
      assData(state, s);
    });
  },
});

export const getLoaded = () => {
  return _getLoaded(EnumReducers.tabBar);
};

export const getDefaultSetting = () => {
  return createSelector(
    (state: Record<string, any>) =>
      state.salesChannelContent.tabBar.defaultSetting,
    (v) => v,
  );
};

export const getSettingList = () => {
  return createSelector(
    (state: Record<string, any>) =>
      state.salesChannelContent.tabBar.TabBarSettingList,
    (v) => v,
  );
};

export const getNewSettingList = () => {
  return createSelector(
    (state: Record<string, any>) =>
      state.salesChannelContent.tabBar.newTabBarSettingList,
    (v) => v,
  );
};

export const getTimeZone = () => {
  return createSelector(
    (state: any) => state.salesChannelContent.tabBar.timezoneGmt,
    (v) => v,
  );
};

export const getSalesChannelContent = () => {
  return createSelector(
    (state: any) => state.salesChannelContent.tabBar.salesChannelContent,
    (v) => v,
  );
};

export const getSalesChannelName = () => {
  return createSelector(
    (state: any) => state.salesChannelContent.tabBar.salesChannelName,
    (v) => v,
  );
};

export const getOpenList = () => {
  return createSelector(
    (state: any) => state.salesChannelContent.tabBar.openList,
    (v) => v,
  );
};

export const getHasModified = () => {
  return createSelector(
    (state: Record<string, any>) =>
      state.salesChannelContent.tabBar.hasModified,
    (hasModified) => {
      return hasModified;
    },
  );
};
export const getLoading = () => {
  return createSelector(
    (state: any) => state.salesChannelContent.tabBar.loading,
    (v) => v,
  );
};

export const getContentUuid = () => {
  return createSelector(
    (state: any) => state.salesChannelContent.tabBar.contentUuid,
    (v) => v,
  );
};

export const getOccupiedRanges = (id: string) => {
  return createSelector(
    (state: Record<string, any>) =>
      state.salesChannelContent.tabBar.TabBarSettingList,
    (state: Record<string, any>) => state.salesChannelContent.tabBar.openList,
    (TabBarSettingList, openList) => {
      const result = [];
      const id = openList[0];
      if (Array.isArray(TabBarSettingList)) {
        TabBarSettingList.filter((setting) => setting.id !== id).forEach(
          (setting) => {
            const start = moment(setting.startTime);
            const end = moment(setting.endTime);
            const beginDate = start ? start.format('YYYY-MM-DD') : '';
            const beginTime = start ? start.format('HH:mm') : '';
            const endDate = end ? end.format('YYYY-MM-DD') : '';
            const endTime = end ? end.format('HH:mm') : '';
            result.push({ beginDate, beginTime, endDate, endTime });
          },
        );
      }
      return result;
    },
  );
};

export const getTimeData = () => {
  return createSelector(
    (state: Record<string, any>) => state.salesChannelContent.tabBar.openList,
    (state: Record<string, any>) =>
      state.salesChannelContent.tabBar.TabBarSettingList,
    (openList, TabBarSettingList) => {
      const id =
        Array.isArray(openList) && openList.length !== 0 ? openList[0] : '';
      const item =
        Array.isArray(TabBarSettingList) && id
          ? TabBarSettingList.find((t) => t.id === id)
          : {};
      return { startTime: item?.startTime, endTime: item?.endTime };
    },
  );
};

export const getCurrentTabBar = () => {
  return createSelector(
    (state: Record<string, any>) => state.salesChannelContent.tabBar.openList,
    (state: Record<string, any>) => state.salesChannelContent.tabBar,
    (openList, tabBar) => {
      const id =
        Array.isArray(openList) && openList.length !== 0 ? openList[0] : '';
      const { TabBarSettingList, newTabBarSettingList, defaultSetting } =
        tabBar;
      const index = defaultSetting.id === id ? 1 : -1;
      const index1 = TabBarSettingList.findIndex((v) => v.id === id);
      const index2 = newTabBarSettingList.findIndex((v) => v.id === id);
      if (index !== -1) return defaultSetting;
      if (index1 !== -1) return TabBarSettingList[index1];
      if (index2 !== -1) return newTabBarSettingList[index2];
    },
  );
};

export const getState = () => {
  return _getState(EnumReducers.tabBar);
};

export const {
  onDefaultChange,
  onCustomSettingChange,
  onAddNewCustomerSetting,
  onOpenTabBarSetting,
  onNewSettingChange,
  onFinishAddingNew,
  onDuplicateSetting,
  onDeleteTabBarSetting,
  onRestoreDefaultSetting,
  validation,
} = salesChannelContentTabBar.actions;

export default salesChannelContentTabBar.reducer;
